// 团队与权限管理模块

//获取部门
function getDepartment(code) {
  return new Promise(resolve => {
    var obj = { instcode: code };
    $.ajax({
      url: APIB,
      async: true,
      type: "post",
      dataType: "json",
      data: { action: "edit", userid: Cookies.get("userid-b"), jsparam: JSON.stringify(obj), pagename: "bGetInstInfo" },
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            if (jsonRes.status == "ok") {
              if (code == "0000000000") {
                resolve(jsonRes.msg.children[0].children);
              } else {
                let children = [];
                children.push(jsonRes.msg);
                resolve(children);
              }
            } else {
              console.log("获取部门出错");
              resolve(false);
            }
          } catch (e) {
            console.log("获取部门出错");
            resolve(false);
          }
        } else {
          console.log("获取部门出错");
          resolve(false);
        }
      }
    });
  });
}

//新增部门
function addDepartment(obj) {
  return new Promise(resolve => {
    $.ajax({
      url: APIB,
      async: true,
      type: "post",
      dataType: "json",
      data: { action: "save", userid: Cookies.get("userid-b"), entid: Cookies.get("entid-b"), jsparam: JSON.stringify(obj), pagename: "bSaveInstInfo" },
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(true) : resolve(false);
          } catch (e) {
            console.log("新增部门出错");
            resolve(false);
          }
        } else {
          console.log("新增部门出错");
          resolve(false);
        }
      }
    });
  });
}

//删除部门
function deleteDepartment(obj) {
  return new Promise(resolve => {
    $.ajax({
      url: APIB,
      async: true,
      type: "post",
      dataType: "json",
      data: { action: "del", userid: Cookies.get("userid-b"), entid: Cookies.get("entid-b"), jsparam: JSON.stringify(obj), pagename: "bDelInstInfo" },
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes) : resolve(false);
          } catch (e) {
            console.log("删除部门出错");
            resolve(false);
          }
        } else {
          console.log("删除部门出错");
          resolve(false);
        }
      }
    });
  });
}

//获取部门下的所有人员
function departmentMember(instcode) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "edit", userid: Cookies.get("userid-b"), pagename: "bGetUserInfoByInstcode", instcode },
      success: res => {
        try {
          if (res) {
            let str = JSON.parse(res);
            resolve(str.status === "ok" ? str.msg : false);
          } else {
            resolve(false);
          }
        } catch (e) {
          resolve(false);
        }
      }
    });
  });
}

//新增成员
function addAdmin(data, codeList) {
  return new Promise(resolve => {
    $.ajax({
      url: APIB,
      async: true,
      type: "post",
      dataType: "json",
      data: { action: "save", userid: Cookies.get("userid-b"), entid: Cookies.get("userid-b"), pagename: "bSaveLowUserInfo", accoutInfo: JSON.stringify(data), powerlist: codeList },
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(true) : resolve(false);
          } catch (e) {
            console.log("新增成员出错");
            resolve(false);
          }
        } else {
          console.log("新增成员出错");
          resolve(false);
        }
      }
    });
  });
}

//获取团队成员
function groupMember(userid = Cookies.get("userid-b")) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { action: "edit", userid, pagename: "bGetUserList" },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            console.log("获取团队成员出错");
            resolve(false);
          }
        } else {
          console.log("获取团队成员出错");
          resolve(false);
        }
      }
    });
  });
}

//重置用户下级列表
function refreshInferior() {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "edit", userid: Cookies.get("userid-b"), pagename: "bReInsetUserList" },
      success: res => {
        let str = JSON.parse(res);
        console.log(str);
      }
    });
  });
}

//获取权限组
function purviewGroup() {
  return new Promise(resolve => {
    $.ajax({
      url: APIB,
      async: true,
      dataType: "json",
      type: "post",
      data: { action: "edit", userid: Cookies.get("userid-b"), entid: Cookies.get("userid-b"), pagename: "bGetPowerList" },
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            if (jsonRes.status == "ok") {
              jsonRes.msg ? resolve(jsonRes.msg) : resolve(false);
            } else {
              console.log("获取权限组出错");
              resolve(false);
            }
          } catch (e) {
            console.log("获取权限组出错");
            resolve(false);
          }
        } else {
          console.log("获取权限组出错");
          resolve(false);
        }
      }
    });
  });
}

//获取权限组内容
function purviewGroupList(type) {
  return new Promise(resolve => {
    $.ajax({
      url: APIB,
      async: true,
      type: "post",
      dataType: "json",
      data: { action: "edit", userid: Cookies.get("userid-b"), entid: Cookies.get("userid-b"), pagename: "bGetDefInf", roletype: type },
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            console.log("获取权限组内容出错");
            resolve(false);
          }
        } else {
          console.log("获取权限组内容出错");
          resolve(false);
        }
      }
    });
  });
}

//设置下级用户权限
function setInferiorPurview(userid, powerlist, instcode, nation) {
  let dataJson = { powerlist: powerlist, instcode: instcode, nations: nation };
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { action: "save", userid: userid, pagename: "bSaveUserPowerList", jsoncode: JSON.stringify(dataJson) },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(true) : resolve(false);
          } catch (e) {
            console.log("设置下级用户权限出错");
            resolve(false);
          }
        } else {
          console.log("设置下级用户权限出错");
          resolve(false);
        }
      }
    });
  });
}

//获取团队成员个人权限(包括地区)
function getMemberPurview(userid) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { action: "edit", userid, pagename: "bGetUserPowerList" },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            console.log("获取团队成员个人权限出错");
            resolve(false);
          }
        } else {
          console.log("获取团队成员个人权限出错");
          resolve(false);
        }
      }
    });
  });
}

//获取申请和面试的企业职位数量
function jobMeetDeliveryNum(mdate) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { type: "a", action: "edit", userid: Cookies.get("userid-b"), mdate, pagename: "bGetDateEntJobCount" },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            console.log("获取申请和面试的企业职位数量出错");
            resolve(false);
          }
        } else {
          console.log("获取申请和面试的企业职位数量出错");
          resolve(false);
        }
      }
    });
  });
}

export default {
  getDepartment,
  addDepartment,
  deleteDepartment,
  departmentMember,
  addAdmin,
  groupMember,
  refreshInferior,
  purviewGroup,
  purviewGroupList,
  setInferiorPurview,
  getMemberPurview,
  jobMeetDeliveryNum
};
